<template>
  <QLayout view="lhr lpr lfr">
    <QHeader bordered class="header justify-center">
      <Header />
    </QHeader>

    <QPageContainer class="container">
      <QPage class="flex column">
        <div class="col-grow" v-if="scoreboard">
          <router-view />
        </div>
        <div class="bg-white error" v-if="!scoreboard">
          <div class="header-no-vehicle-app-image" v-if="noVehicleAppImage">
            <img :src="noVehicleAppImage" class="header-logo" />
          </div>
          <div class="header" v-else>
            <img src="/assets/icons/header-logo.svg" class="header-logo" />
          </div>
          <div class="q-px-lg q-py-sm">
            <MainHeadline
              align="center"
              header="No vehicle application found"
              body="It looks like you don't have an active vehicle application in our system."
            />
          </div>
          <div class="q-px-lg q-py-sm">
            <ContactUs />
          </div>
        </div>
      </QPage>
    </QPageContainer>

    <QFooter class="two-column">
      <Footer :twoColumn="true" />
    </QFooter>
  </QLayout>
</template>
<script>
import { QLayout, QPage, QHeader, QFooter, QPageContainer } from 'quasar';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import { mapState, mapGetters } from 'vuex';
import ContactUs from '../components/Atoms/ContactUs';
import MainHeadline from '../components/Atoms/MainHeadline';

/**
 * This component defines a common page layout with slots for:
 * - A Header
 * - A Menu
 * - A Footer
 */
export default {
  name: 'ScoreboardLayout',
  data() {
    return {
      menuOpen: true,
      menuMini: true
    };
  },
  computed: {
    ...mapState({
      scoreboard: (state) =>
        state.vehicleApplication?.vehicleApplication?.scoreboard ? state.vehicleApplication?.vehicleApplication?.scoreboard : null,
      user: (state) => state.auth.user
    }),
    ...mapGetters({
      orgProfile: 'theme/getScoreboard'
    }),
    noVehicleAppImage() {
      return this.orgProfile && this.orgProfile.noVehicleAppImage;
    }
  },
  mounted() {
    // Define a closeMenu receiver as we can not capture emits from slots
    this.$on('closeMenu', () => (this.menuMini = true));
  },
  components: {
    QLayout,
    QPage,
    QHeader,
    QFooter,
    QPageContainer,
    Header,
    Footer,
    ContactUs,
    MainHeadline
  }
};
</script>

<style lang="sass" scoped>
.q-tooolbar
  min-height: 36px;
.q-header
  background: #FFFFFF;
.header
  padding: 5px 0;
.q-header--bordered
  border-bottom: 1px solid #EDEDED;
.error hr
  border: 0;
  border-top: 1px solid #EEEEEE;
.error .header
  padding: 50px 0 98px;
  text-align: center;
  background-color: #E9F3FE;
  background-image: url('/assets/icons/header-background.svg');
  background-position: center top;
  background-repeat: no-repeat;
</style>
